import React from 'react';
import Grid from '@material-ui/core/Grid';
import { InputLabel, FormHelperText, Typography, Divider } from '@material-ui/core';
import { SecondaryButton, formatters, DatePicker } from '../../../../../../Core/Controls';
import '../../../../../commonStyle.scss';
import SalesLines from './sellerLines';
import EmailTemplate from '../../../../../../Core/Controls/EmailTemplate';
import DialogComp from '../../../../../../Core/Dialog/DialogComp';
import { SellerInvoiceProvider, useSellerInvoice } from './SellerInvoiceContext';

function AddJobItemModalContent() {
    const {
        state,
        btnLoader,
        showMail,
        handleMail,
        getEmailValues,
        inputChange,
        onInvoiceItemChange,
        invoiceLinesCheckField,
        invoiceLinesCheckBox,
        PartSelectChange,
        handleFields,
        handelandEmailSubmit,
        handelSubmit,
        handlescheduleDocsChange,
        handlejobDocsChange,
        props
    } = useSellerInvoice();

    return (
        <div style={{ height: '100%' }}>
            {!props.loader && (
                <>
                    {!props.hideDetailBar && (
                        <Grid container spacing={0} className="mt_10">
                            <Grid item xs={12} lg={12}>
                                <Grid item container xs={12} style={{ backgroundColor: '#f5f9f9', padding: '0 5px' }}>
                                    <Grid item xs={6} sm={3}>
                                        <FormHelperText shrink>Reg Number</FormHelperText>
                                        <Typography variant="subtitle2">{state.vehicleDetails[0]?.regNumber || 'N/A'}</Typography>
                                    </Grid>
                                    <Grid item xs={6} sm={3}>
                                        <FormHelperText shrink>Order No</FormHelperText>
                                        <Typography variant="subtitle2">{state.vehicleDetails[0]?.orderRef || 'N/A'}</Typography>
                                    </Grid>
                                    <Grid item xs={6} sm={3}>
                                        <FormHelperText shrink>Customer</FormHelperText>
                                        <Typography variant="subtitle2">{state.vehicleDetails[0]?.customer || 'N/A'}</Typography>
                                    </Grid>
                                    <Grid item xs={6} sm={3}>
                                        <FormHelperText shrink>Booked Date</FormHelperText>
                                        <Typography variant="subtitle2">{formatters.DateOnlyFormatter(state.vehicleDetails[0]?.bookedDate)}</Typography>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>
                    )}
                    <Grid container spacing={1}>
                        {!props.hideInputs && (
                            <>
                                <Grid item xs={12} sm={3} lg={3} className="mandatory-fields">
                                    <InputLabel shrink required>
                                        Invoice Date
                                    </InputLabel>
                                    <DatePicker
                                        placeholder="Invoice Date"
                                        value={state.purchaseInvoiceDate}
                                        onChange={inputChange}
                                        name="purchaseInvoiceDate"
                                    />
                                    <FormHelperText error>{state.errors.purchaseInvoiceDate}</FormHelperText>
                                </Grid>
                                <Grid item xs={12} sm={3} lg={3} className="mandatory-fields">
                                    <InputLabel shrink required>
                                        Due Date
                                    </InputLabel>
                                    <DatePicker
                                        placeholder="Due Date"
                                        value={state.purchaseInvoiceDateDue}
                                        onChange={inputChange}
                                        name="purchaseInvoiceDateDue"
                                    />
                                    <FormHelperText error>{state.errors.purchaseInvoiceDateDue}</FormHelperText>
                                </Grid>
                                <Grid item xs={12} sm={3} md={3} lg={2}>
                                    <InputLabel shrink>{'\u{2800}'}</InputLabel>
                                    <SecondaryButton onClick={handelSubmit} isBtnLoader={btnLoader}>
                                        Submit
                                    </SecondaryButton>
                                </Grid>
                            </>
                        )}
                        {props.disabled && props.salesInvoiceStatus === 'P' && !state.vehicleDetails[0]?.isProforma && state.isRechargeLine && (
                            <Grid item xs={6}>
                                <InputLabel shrink>{'\u{2800}'}</InputLabel>
                                {state.vehicleDetails[0]?.openLines || props.mismatchedLines ? null : (
                                    <SecondaryButton onClick={handleMail} isBtnLoader={btnLoader} disabled={btnLoader}>
                                        Create proforma & Email
                                    </SecondaryButton>
                                )}
                            </Grid>
                        )}
                        {props.disabled && props.salesInvoiceStatus === 'P' && state.vehicleDetails[0]?.isProforma && (
                            <Grid item xs={6}>
                                <InputLabel shrink>{'\u{2800}'}</InputLabel>
                                {state.vehicleDetails[0]?.openLines || props.mismatchedLines ? null : (
                                    <SecondaryButton onClick={handleMail} isBtnLoader={btnLoader} disabled={btnLoader}>
                                        Email proforma
                                    </SecondaryButton>
                                )}
                            </Grid>
                        )}
                        {props.disabled && props.salesInvoiceStatus === 'I' && state.vehicleDetails[0]?.isProforma && state.scheduleDocs.length > 0 && (
                            <Grid item xs={6}>
                                <InputLabel shrink>{'\u{2800}'}</InputLabel>
                                {state.vehicleDetails[0]?.openLines || props.mismatchedLines ? null : (
                                    <SecondaryButton onClick={handleMail} isBtnLoader={btnLoader} disabled={btnLoader}>
                                        Create Invoice & Email Document
                                    </SecondaryButton>
                                )}
                            </Grid>
                        )}
                        {props.disabled && (
                            <Grid
                                item
                                xs={
                                    props.salesInvoiceStatus === 'P'
                                        ? !state.isRechargeLine
                                            ? 12
                                            : 6
                                        : props.salesInvoiceStatus === 'I' && state.vehicleDetails[0]?.isProforma && state.scheduleDocs.length > 0
                                          ? 6
                                          : 12
                                }
                            >
                                <InputLabel shrink>{'\u{2800}'}</InputLabel>
                                {state.vehicleDetails[0]?.openLines || props.mismatchedLines ? null : (
                                    <SecondaryButton onClick={handelSubmit} isBtnLoader={btnLoader} disabled={btnLoader}>
                                        {props.salesInvoiceStatus === 'P' && !state.vehicleDetails[0]?.isProforma && state.isRechargeLine
                                            ? 'Create proforma'
                                            : props.salesInvoiceStatus === 'I' && state.isRechargeLine
                                              ? 'Create Invoice'
                                              : props.salesInvoiceStatus === 'P' && !state.isRechargeLine && props.jobStatus === 'AS'
                                                ? 'Submit and Close Job'
                                                : 'Submit'}
                                    </SecondaryButton>
                                )}
                            </Grid>
                        )}{' '}
                        {showMail && (
                            <DialogComp
                                onClose={handleMail}
                                title={state.vehicleDetails[0]?.isProforma ? 'Send Email' : 'Create proforma & Email'}
                                maxWidth="lg"
                                overflow="auto"
                                fullScreen
                            >
                                <EmailTemplate
                                    // initialEmail={state.vehicleDetails[0]?.authorityEmail}
                                    // initialSubject={state.vehicleDetails[0]?.authoritySub}
                                    // initialBody={state.vehicleDetails[0]?.authorityBody}
                                    getEmailValues={getEmailValues}
                                    isProforma={state.vehicleDetails[0]?.isProforma}
                                    scheduleDocs={state.scheduleDocs}
                                    handlescheduleDocsChange={handlescheduleDocsChange}
                                    jobDocs={state.jobDocs}
                                    handlejobDocsChange={handlejobDocsChange}
                                    salesInvoiceStatus={props.salesInvoiceStatus}
                                    scheduleJobID={props.scheduleJobID}
                                    customerID={props.customerID}
                                />
                            </DialogComp>
                        )}
                        <Grid item xs={12}>
                            <SalesLines
                                invoiceLinesCheckBox={invoiceLinesCheckBox}
                                invoiceLinesCheckField={invoiceLinesCheckField}
                                PartSelectChange={PartSelectChange}
                                handleFields={handleFields}
                                invoiceLines={state.invoiceLines}
                                partsDetails={state.partsDetails}
                                vatRate={state.vatRate}
                                onInvoiceItemChange={onInvoiceItemChange}
                                invoiceItemVATRateID={state.invoiceItemVATRateID}
                            />
                        </Grid>
                    </Grid>
                </>
            )}
        </div>
    );
}

function AddJobItemModal(props) {
    return (
        <SellerInvoiceProvider props={props}>
            <AddJobItemModalContent />
        </SellerInvoiceProvider>
    );
}

export default AddJobItemModal;
